import { exchActPrizeInfo, GoodsType, promShowGoodsInfo, userCouponList, } from '@tencent/wphk-act-base-cgi';
import { ActivityCouponState } from '@tencent/wphk-act-base-types';
import { leftJoin } from '../../utils';
import { cacheGoodsInfo, clearGoodsInfo, getCacheGoodsInfo } from './cache-goods-info';
import { transformCouponsV2 } from './format-coupon';
import { CustomException } from '@tencent/ppd-base-libs';
/** 查询券列表类型 */
export var QryType;
(function (QryType) {
    /** 通过活动 id 列表查询 */
    QryType["ByActIdList"] = "ByActIdList";
    /** 通过资格 id 列表查询 */
    QryType["ByQualIdList"] = "ByQualIdList";
})(QryType || (QryType = {}));
/** 每张券的状态权重 默认配置 */
export const DEFAULT_COUPON_SORT_STATE = [
    ActivityCouponState.expired,
    ActivityCouponState.received,
    ActivityCouponState.totalLimit,
    ActivityCouponState.dayLimit,
    ActivityCouponState.notReceived,
];
/** 查询券列表 */
export async function qryAndFormatCouponList(params) {
    const { couponStateSort = DEFAULT_COUPON_SORT_STATE } = params;
    console.log('core qryAndFormatCouponList start ==>', params);
    const { actCouponList, userCouponList, couponGoodsInfo } = await qryAllCouponList(params);
    const couponList = leftJoin(leftJoin(actCouponList, userCouponList, 'prizeId', 'couponId', true), couponGoodsInfo, 'prizeId', 'goodsEnId');
    // 格式化券列表
    const results = transformCouponsV2(couponList, couponStateSort);
    console.log('core qryAndFormatCouponList end ==>', results);
    return results;
}
/** 查询所有券数据 */
async function qryAllCouponList(params) {
    const { qryType, qryIdList, isNeedUserCouponid = true, isCacheGoodsInfo = true } = params;
    // 根据活动id列表活着资格id列表查询券、活动信息
    const actCouponList = await qryExchActPrizeInfo(qryType, qryIdList);
    // 券 id 列表
    const couponIdList = actCouponList.map((coupon) => coupon.prizeId);
    // 根据券id列表查询用户已领取的券id信息、根据券id列表查询静态券信息
    const { userCouponList, couponGoodsInfo } = await qryCouponBaseList({
        qryIdList,
        couponIdList,
        isNeedUserCouponid,
        isCacheGoodsInfo,
    });
    return {
        actCouponList,
        userCouponList,
        couponGoodsInfo,
    };
}
/** 查询券基本数据 */
async function qryCouponBaseList({ qryIdList, couponIdList, isNeedUserCouponid, isCacheGoodsInfo, }) {
    if (!couponIdList.length) {
        return new CustomException('', 'qryCouponListParamsEmpty', 'userCouponList/qryGoodsInfo参数为空');
    }
    const results = {
        userCouponList: [],
        couponGoodsInfo: [],
    };
    const qryPromiseList = [];
    // 1. 根据券id列表查询用户已领取的券id信息
    if (isNeedUserCouponid) {
        qryPromiseList.push(qryUserCouponList(couponIdList).then((result) => {
            results.userCouponList = result;
        }));
    }
    // 2. 根据券id列表查询静态券信息
    if (!isCacheGoodsInfo)
        clearGoodsInfo(); // 如果不需要缓存，则清掉缓存数据
    const cacheData = isCacheGoodsInfo ? getCacheGoodsInfo(qryIdList) : null;
    if (cacheData) {
        results.couponGoodsInfo = cacheData;
    }
    else {
        qryPromiseList.push(qryGoodsInfo(couponIdList).then((result) => {
            results.couponGoodsInfo = result;
            // 进行缓存
            if (isCacheGoodsInfo) {
                cacheGoodsInfo(qryIdList, result);
            }
        }));
    }
    if (qryPromiseList.length !== 0) {
        await Promise.all(qryPromiseList);
    }
    return results;
}
/** 查券方法 1：根据活动id列表活着资格id列表查询券、活动信息 */
async function qryExchActPrizeInfo(qryType, qryIdList) {
    if (!qryIdList.length) {
        return new CustomException('', 'qryCouponListParamsEmpty', 'exchActPrizeInfo参数为空');
    }
    let actPrizeInfoData;
    if (QryType.ByActIdList === qryType) {
        actPrizeInfoData = await exchActPrizeInfo({ exchActidList: qryIdList, statUserCpn: 1, qryQualAct: 1 });
        // 用活动查，活动信息是返回在exchActidList里面的
        return formatExchActPrizeInfo(actPrizeInfoData);
    }
    if (QryType.ByQualIdList === qryType) {
        actPrizeInfoData = await exchActPrizeInfo({ qualIdList: qryIdList, statUserCpn: 1, qryQualAct: 1 });
        // 用资格查询，活动信息是返回在qualExchActidList字段里面的，需要处理下
        return formatExchActPrizeInfo(Object.assign(Object.assign({}, actPrizeInfoData), { exchActidList: actPrizeInfoData.qualExchActidList }));
    }
    return [];
}
/** 查券方法 2：根据券id列表查询用户已领取的券id信息 */
async function qryUserCouponList(couponIdList) {
    const data = await userCouponList({ couponIdList });
    const cpCouponList = (data.cpInfo || []).map((ele) => ({
        couponId: ele.couponId,
        transState: ele.transState,
        userCouponid: ele.userCouponid,
    }));
    const spCouponList = (data.spInfo || []).map((ele) => ({
        couponId: ele.couponId,
        transState: ele.transState,
        // @ts-ignore
        userCouponid: ele.userCouponid || ele.userScid,
    }));
    return [...cpCouponList, ...spCouponList];
}
/** 查券方法 3：根据券id列表查询静态券信息 */
async function qryGoodsInfo(couponIdList) {
    const data = await promShowGoodsInfo({ goodsType: GoodsType.coupon, goodsIdList: couponIdList });
    return data === null || data === void 0 ? void 0 : data.goodsArr;
}
/** 格式化券、活动信息 */
function formatExchActPrizeInfo(actPrizeInfo) {
    const { couponInfoList, exchActidList, qualInfoList = [] } = actPrizeInfo;
    // 格式校验
    if (!couponInfoList || !exchActidList)
        return [];
    const couponInfoListFormated = couponInfoList.map((ele) => ({
        couponId: ele.couponId,
        enCouponid: ele.enCouponid,
        hasGot: ele.hasGot,
    }));
    const qualInfoListFormated = qualInfoList.map((ele) => ({ actId: ele.actId, qualId: ele.qualId }));
    return leftJoin(leftJoin(exchActidList, couponInfoListFormated, 'prizeId', 'enCouponid', true), qualInfoListFormated, 'actId', 'actId');
}
